/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align */

import {ProjectElement}          from './project.element';
import {ProjectElementType}      from './project.element.type';
import { BlobType }              from '../blob';

import { Project }               from '../project';

import { Logger }                from '@/util/logger';

import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";
import {FileBrowserMetadata} from "@/screens/ide/file.browser.metadata";

/**
 *
 * @class BatchSummariesElement
 *
 * root element for all the batch summaries (line-to-batch items) in the project
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
@ProjectElementFactoryDecorator('BatchSummariesElement')
export class BatchSummariesElement extends ProjectElement {

  public actionKeys: string[] = [
    'newbatchsummary',
    'viewinbrowser'
  ];

  /** standard constructor */
  constructor(
    project: Project,
    id: string,
    parent: ProjectElement,
    label: string = 'Batch Summaries',
    publish: boolean = false
  ) {

    super(project, id, ProjectElementType.BatchSummaries);

    this._acceptsElements.push(ProjectElementType.BatchMeasure);
    this._acceptsBlobs.push(BlobType.None);

    this._enabled     = true;
    this._label       = label;
    this._icon        = 'fa fa-share-alt';
    this._elementKind = 'Batch Summaries';

    if (parent) {

      this._project.addElement(this, parent, publish);
    }

  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring BatchSummariesElement");
  }

  /** is this element deletable? */
  public isDeletable() : boolean {

    return false;
  }

  /**
   * subclasses must add their menu item definition(s) to the given action set,
   * in jquery-contextmenu fashion.
   *
   * @param actionSet any
   *
   */
  public actions(actionSet: any): any {

    actionSet.newbatchsummary = {
      name: 'New Batch Summary',
      icon: 'fas fa-plus',
      disabled: this.isBusy()
    };

    actionSet.viewinbrowser = {
      name: 'Folder Of',
      icon: 'fas fa-list',
      disabled: false
    };

    return actionSet;
  }

  /** test if this element accepts the given action */
  public acceptsAction(key: string): boolean {

    if (!!this.actionKeys.find(x => x === key)) {

      return true;
    }

    return this._parent.acceptsAction(key);
  }

  /** subclasses must implement their own actions */
  public action(key: string, selection: ProjectElement[]) {

    switch (key) {

      case 'viewinbrowser': {

        this._project.services.ide.launchWindow(FileBrowserMetadata.build(this._blobKey, this._blobKey));

        return;
      }
    }

    return super.action(key, selection);
  }


}
